import React, { useState, useCallback, useEffect } from "react"
import * as styles from "./Topics-tw-styles"
import Typography from "../../components/UI/Typography/Typography"
import { BrandsData as allBrandsData, filterLabel } from "./TopicsJson"
import "./Topics.css"
import PropTypes from "prop-types"

const style = styles.defaultStyle

const Topics = props => {
  const { items = [] } = props
  const [brands, SetBrands] = useState(allBrandsData)
  const [toggle, setToggle] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState("")

  const handleSelectChange = useCallback(
    (category, catid) => () => {
      if (category?.label === "Clear All") {
        setSelectedCategory("")
        SetBrands(allBrandsData)
      } else {
        //select functionality
        if (selectedCategory != category) {
          setSelectedCategory(
            prevState =>
              //...prevState,
              category
          )
        } else {
          //de-select functionality
          setSelectedCategory("")
        }
      }
    },
    [selectedCategory, setSelectedCategory]
  )

  useEffect(() => {
    if (selectedCategory == "") {
      return
    }
  }, [selectedCategory])

  function renderCategoryList() {
    return items?.map(item => (
      <li
        className={`${style?.brandFilterRow} ${
          selectedCategory === item.label ? "activated" : ""
        }`}
        key={item?.id}
        onClick={handleSelectChange(item?.label, item?.id)}
        id="changeBrands"
      >
        <Typography className={style?.filterText} content={item?.label} />
      </li>
    ))
  }

  function setToggleValue() {
    setToggle(!toggle)
  }

  return (
    <>
      <div className={style?.brandLabelWrapper}>
        <div
          className={
            toggle ? "expandBrands brandLabel" : "collpaseBrands brandLabel"
          }
          onClick={() => setToggleValue()}
          id="tabClick"
        >
          <p> {filterLabel} </p>
        </div>
      </div>

      <div className={style?.brandFilterWrapper}>
        <ul
          className={style?.brandFiltersList}
          style={{ maxHeight: toggle ? "100vh" : "0" }}
          data-testid="listingFilter"
        >
          {items && renderCategoryList()}
        </ul>
      </div>
    </>
  )
}

Topics.propTypes = {
  items: PropTypes.array,
}

export default Topics
